export { default } from "./DigiwashServicesSection-component";
